import { atom } from "recoil";

const loseScreenState = atom<boolean>({
  key: "loseScreenState",
  default: false,
});

export default loseScreenState;
